export default {
    teethIdsUpper: [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27],
    teethIdsLower: [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37],
    prevAddDirection: 1,
    prevAddCnt: 0,

    getAvailableRange(group, groups) {
        let activeJaw = group.selectedRegion < 3 ? 'upper' : 'lower';
        let rangeMins = [];
        let rangeMaxs = [];

        groups.forEach((g) => {
            if(g.id === group.id) return;
            let jaw = g.selectedRegion < 3 ? 'upper' : 'lower';
            if(activeJaw === jaw) {
                rangeMins.push(parseInt(g.rangeRaw[0]));
                rangeMaxs.push(parseInt(g.rangeRaw[1]));
            }
        });

        if (rangeMins.length === 0) return [0,13];

        let min = parseInt(group.rangeRaw[0]);
        let max = parseInt(group.rangeRaw[1]);
        let rangeMinFound = false;
        let rangeMaxFound = false;

        while (!rangeMinFound) {
            if (min <= 0) rangeMinFound = true;
            else {
                if (rangeMaxs.includes(min - 1)) {
                    rangeMinFound = true;
                } else min--;
            }
        }
        while (!rangeMaxFound) {
            if (max >= 13) rangeMaxFound = true;
            else {
                if (rangeMins.includes(max + 1)) {
                    rangeMaxFound = true;
                } else max++;
            }
        }

        return [min, max];
    },

    getImplantPositions2(cnt, selection) {
        /*assuming t = 1..x:

        a[t] = min+t*(max-min) / (x+1)*/
    },

    getImplantPositions(cnt, selection) {
        if (cnt >= selection.length) return selection;
        if (cnt < 2) return [selection[0]];
        let ids = [];
        ids.push(selection[0]);
        cnt--;
        ids.push(selection[selection.length - 1]);
        cnt--;

        // cnt is the remaining implants to be placed

        let idx = 0;
        let rest = 0;
        if(cnt > 0) {
            let parts = ((selection.length) - 2) / (cnt + 1);
            let part = parts;
             while(cnt > 0) {
                 cnt--;
                 idx = Math.round(part);
                 rest = Math.abs(Math.round(part) - part);
                 ids.push(selection[idx]);
                 part += parts + rest;
             }
        }

        return ids;


        if (cnt > 0 && (selection.length -2) >= cnt) {
            let parts = ((selection.length) - 2) / (cnt);
            let rest = 0;
            while(cnt > 0) {
                cnt--;
                parts += rest;
                rest = Math.round(parts) - parts;
                idx += Math.round(parts);
                ids.push(selection[idx]);
            }
        }
        return ids;
    },

    getRangeForCount(cnt, currentRange, start, end) {
        let range = [...currentRange];

        if (this.prevAddCnt !== cnt) this.prevAddDirection = 1 - this.prevAddDirection;
        this.prevAddCnt = cnt;

        if(cnt === 1) {
            if (this.prevAddDirection === 0) range[0] -= 1;
            else range[1] += 1;
        } else {
            if (this.prevAddDirection === 0) range[0] += 1;
            else range[1] -= 1;
        }

        this.prevAddDirection = 1 - this.prevAddDirection;

        if (range[0] < 0) {
            range[0] = 0;
            if (range[1] < 16) range[1] += 1;
        }
        if (range[1] > 16) {
            range[1] = 16;
            if (range[0] > 0) range[0] -= 1;
        }

        return range;
    },

    getPillars(selection) {
        let pillars = this._getPillars(selection);
        for (let i = 0; i< pillars.length; i++) {
            pillars[i] = String(pillars[i]);
        }

        if (pillars.includes('11') && pillars.includes('12') && pillars.includes('21') && pillars.includes('22')) {
            pillars.splice(pillars.indexOf('11'), 1);
            pillars.splice(pillars.indexOf('21'), 1);
        }
        if (pillars.includes('31') && pillars.includes('32') && pillars.includes('41') && pillars.includes('42')) {
            pillars.splice(pillars.indexOf('31'), 1);
            pillars.splice(pillars.indexOf('41'), 1);
        }

        ['1','2','3','4'].forEach(regionId => {
            if (pillars.includes(regionId + '1') && pillars.includes(regionId + '2') && pillars.includes(regionId + '3')) {
                pillars.splice(pillars.indexOf(regionId + '2'), 1);
            }
        });
        return pillars;
    },


    _getPillars(selection) {
        const pillars = [];

        if (selection.length < 2) {
            return selection;
        }

        selection = Helper.sortToothNumbers(selection);

        // Ha 4tagú -> 2 szélső a pillér
        if (selection.length === 4) {
            pillars.push(selection[0]);
            pillars.push(selection[3]);
            return Helper.sortToothNumbers(pillars);
        }

        // Ha (n/2) páratlan -> normál mód, minden második kimarad
        if (selection.length % 2 === 1) {
            for (const i in selection) {
                if (i % 2 === 0) {
                    pillars.push(selection[i]);
                }
            }

            return pillars;
        }

        // Front fogak számítása
        let fronts = 0;
        let frontReached = false;

        for (const i in selection) {
            if (selection[i] % 10 === 1) {
                fronts++;
            }
        }

        // Ha n/2 páros és szimmetrikus és 8-8 v 6-6 v 4-4 v 2-2
        if (selection[0] % 2 == 0 && selection[0] % 10 === selection[selection.length - 1] % 10) {
            for (const i in selection) {
                if (selection[i] % 10 === 1) {
                    frontReached = true;
                    continue;
                }

                if (!frontReached && i % 2 === 0) pillars.push(selection[i]);
                if (frontReached && i % 2 === 1) pillars.push(selection[i]);
            }

            return pillars;
        }

        // Ha (n/2 páros ÉS csak egy egyes van jelölve) -> 1-es és 2-es pillér/implant
        if (fronts === 1) {
            for (const i in selection) {
                if (i % 2 === 0 || selection[i] % 10 === 1 || selection[i] % 10 === 2) pillars.push(selection[i]);
            }
            return pillars;
        }

        // Ha (n/2 páros ÉS két egyes van jelölve) -> a 2 egyes a pillér/implant
        if (fronts === 2) {
            for (const i in selection) {
                if (selection[i] % 10 === 1) {
                    pillars.push(selection[i]);
                    frontReached = true;
                    continue;
                }
                if (!frontReached && i % 2 === 0) pillars.push(selection[i]);
                if (frontReached && i % 2 === 1) pillars.push(selection[i]);
            }
            return pillars;
        }

        // Ha (n/2 páros és nincs egyes) -> a frontokhoz legközelebbi 2 fog pillér/implant
        if (fronts === 0) {
            for (const i in selection) {
                if (Math.floor(selection[0] / 10) === 1 || Math.floor(selection[0] / 10) === 4) {
                    if (i % 2 === 0) pillars.push(selection[i]);
                } else if (i % 2 === 1) pillars.push(selection[i]);
            }
            if (Math.floor(selection[0] / 10) === 1 || Math.floor(selection[0] / 10) === 4) {
                pillars.push(selection[selection.length - 1]);
                pillars.push(selection[selection.length - 2]);
            } else {
                pillars.push(selection[0]);
                pillars.push(selection[1]);
            }
            return Helper.sortToothNumbers(pillars);
        }

        return [];
    },

    breakToParts(selection) {
        const parts = [];
        let subSelection = [];
        let prevId = null;

        selection.forEach((tId) => {
            if (prevId !== null) {
                if (!Helper.isAdjacents(prevId, tId)) {
                    parts.push(JSON.parse(JSON.stringify(subSelection)));
                    subSelection = [];
                }
            }
            subSelection.push(tId);
            prevId = tId;
        });

        if (subSelection.length > 0) parts.push(JSON.parse(JSON.stringify(subSelection)));

        return parts;
    },
}
